export enum TranscriptionType {
  Dictation = 'DICTATION',
  Conversation = 'CONVERSATION',
}

export const transcriptionTypeOptions = [
  { value: TranscriptionType.Dictation, label: 'Dictation' },
  { value: TranscriptionType.Conversation, label: 'Conversation' },
];
